import { Column } from "Components/Grid";
import styled from "styled-components";

export const TitleLogin = styled.span`
    font-family: var(--font-primary);
    font-style: normal;
    font-weight: 300;
    font-size: 40px;
    color: var(--color-brand);
    &.bold {
        font-weight: 700;
    }
`
export const SubtitleLogin = styled.span`
    font-family: var(--font-primary);
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    color: var(--color-brand);
`
export const Observation = styled.p`
    font-family: var(--font-body);
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: var(--vo-slate);
    margin-bottom: 24px;
    span {
        font-weight: 700;
    }
`
export const HasAccount = styled.p`
    font-family: var(--font-body);
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: var(--vo-slate);
    button {
        border: none;
        background: transparent;
        width: fit-content;
        font-weight: 700;
        color: var(--color-brand);
        &:hover {
            cursor: pointer;
        }
    }
`
export const SucessContent = styled(Column)`
    font-family: var(--font-primary);
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    font-feature-settings: 'liga' off;
    color: var(--vo-ink);
    margin: 0 auto 48px;
    text-align: center;
`